<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-video-watchlist">
      <div class="bmw-lg-video-header">
        <div class="row bmw-no-gutter">
          <div class="col-lg-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='video.videoTitle' width="250px" height="140px" />
          </div>
          <div class="col-lg-8 bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-lg-video-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-lg-video-watchlist-info">{{videoList?.length}} videos</div>
            <div class="row bmw-no-gutter" style="margin-top: 15px">
              <div class="col-lg-3 bmw-no-gutter">
                <a [routerLink]='["/playback"]' [queryParams]='{channel: "", video: "", watchlist: true, playAll: true}'>
                  <div class="bmw-lg-video-watchlist-header-button" style="width:100px">
                    <div>
                      <i class="material-icons d48">play_circle_filled</i>
                    </div>
                    <div class="bmw-lg-video-watchlist-header-button-label">
                      Play All
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div class="col-lg-4 bmw-no-gutter">
                <div class="bmw-lg-video-watchlist-header-button" style="width:155px">
                  <div>
                    <i class="material-icons d48">delete_forever</i>
                  </div>
                  <div class="bmw-lg-video-watchlist-header-button-label">
                    Remove Watched
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-lg-3 bmw-no-gutter">
                <div class="bmw-lg-video-watchlist-header-button" style="width:116px">
                  <div>
                    <i class="material-icons d48">add_circle</i>
                  </div>
                  <div class="bmw-lg-video-watchlist-header-button-label" data-toggle="modal" data-target="#addVideos">
                    Add Videos
                  </div>
                  <div class="modal fade" id="addVideos" tabindex="-1" role="dialog" aria-labelledby="addVideosLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content bmw-lg-watchlist-add-videos-modal">
                        <div class="modal-header">
                          <h5 class="modal-title" id="addVideosLabel">Add Video to Watchlist</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          ...
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-primary">Save changes</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-video-watchlist-list" dnd-sortable-container [sortableData]="videoList" [dropZones]="['widget-dropZone']">
        <div *ngFor='let video of videoList;let videoIndex=index' class="row bmw-no-gutter bmw-lg-video-watchlist-list-video" dnd-sortable
          [sortableIndex]="videoIndex" [dragEnabled]="true" [dragData]="video" (onDropSuccess)="transferDataSuccess($event)">
          <div class="col-lg-1" style="font-size: 20px; line-height: 2.7">
            <div class="col-lg-6 bmw-no-gutter" style="margin-left: -14px">
              <div class="bmw-video-watchlist-item-holder">
                <i class="material-icons" style="font-size:20px">unfold_more</i>
              </div>
            </div>
            <div class="col-lg-6 bmw-no-gutter" style="margin-left: 4px;padding:16px 0 16px 0">{{videoIndex+1}}</div>
          </div>
          <div class="col-lg-2 bmw-no-gutter" style="margin-left: -45px; padding:16px 0 16px 0">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]' [queryParams]='{channel: video.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: true}'>
              <img style="cursor: pointer" src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-lg-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-lg-8 bmw-no-gutter" style="padding:16px 0 16px 0">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-lg-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px;padding:16px 0 16px 0">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemTop(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemBottom(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemUp(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemDown(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(video.id)'>
                  <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-video-channel-btn" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md-video-watchlist">
      <div class="bmw-md-video-header">
        <div class="row bmw-no-gutter">
          <div class="col-md-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='video.videoTitle' width="250px" height="100px" />
          </div>
          <div class="col-md-8 bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-md-video-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-md-video-watchlist-info">{{videoList?.length}} videos | 3 hours 38 minutes</div>
            <div class="row bmw-no-gutter" style="margin-top: 10px">
              <a [routerLink]='["/playback"]' [queryParams]='{channel: "", video: "", watchlist: true, playAll: true}'>
                <div class="bmw-md-video-watchlist-header-button" style="width:100px">
                  <div>
                    <i class="material-icons d48">play_circle_filled</i>
                  </div>
                  <div class="bmw-md-video-watchlist-header-button-label">
                    Play All
                  </div>
                </div>
              </a>
              <!-- <div class="bmw-md-video-watchlist-header-button" style="width:155px">
                <div>
                  <i class="material-icons d48">delete_forever</i>
                </div>
                <div class="bmw-md-video-watchlist-header-button-label">
                  Remove Watched
                </div>
              </div> -->
              <!-- <div class="bmw-md-video-watchlist-header-button" style="width:116px">
                <div>
                  <i class="material-icons d48">add_circle</i>
                </div>
                <div class="bmw-md-video-watchlist-header-button-label" data-toggle="modal" data-target="#addVideos">
                  Add Videos
                </div>
                <div class="modal fade" id="addVideos" tabindex="-1" role="dialog" aria-labelledby="addVideosLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content bmw-lg-watchlist-add-videos-modal">
                      <div class="modal-header">
                        <h5 class="modal-title" id="addVideosLabel">Add Video to Watchlist</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        ...
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save changes</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-video-watchlist-list">
        <div *ngFor='let video of videoList;let videoIndex=index' class="row bmw-no-gutter bmw-md-video-watchlist-list-video">
          <div class="col-md-1" style="font-size: 20px; line-height: 2.7">
            {{videoIndex+1}}
          </div>
          <div class="col-md-2 bmw-no-gutter" style="margin-left: -20px;">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]' [queryParams]='{channel: video.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: true}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-md-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-md-8 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-md-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemTop(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemBottom(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemUp(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemDown(videoIndex, video)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(video.id)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-video-channel-btn" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true") ? "#281432":"#1c69d4"}'
        (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-video-watchlist">
      <div class="bmw-lg-video-header">
        <div class="row bmw-no-gutter">
          <div class="col-sm-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='video.videoTitle' width="250px" height="140px" />
          </div>
          <div class="col-sm-8 bmw-no-gutter" style="padding-left: 18px">
            <div class="row bmw-no-gutter bmw-lg-video-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-lg-video-watchlist-info">{{videoList?.length}} videos | 3 hours 38 minutes</div>
            <div class="row bmw-no-gutter" style="margin-top: 15px">
              <div class="col-sm-3 bmw-no-gutter">
                <a [routerLink]='["/playback"]' [queryParams]='{channel: "", video: "", watchlist: true, playAll: true}'>
                  <div class="bmw-lg-video-watchlist-header-button" style="width:100px">
                    <div>
                      <i class="material-icons d48">play_circle_filled</i>
                    </div>
                    <div class="bmw-lg-video-watchlist-header-button-label">
                      Play All
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div class="col-sm-5 bmw-no-gutter">
                <div class="bmw-lg-video-watchlist-header-button" style="width:155px">
                  <div>
                    <i class="material-icons d48">delete_forever</i>
                  </div>
                  <div class="bmw-lg-video-watchlist-header-button-label">
                    Remove Watched
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-sm-3 bmw-no-gutter">
                <div class="bmw-lg-video-watchlist-header-button" style="width:116px">
                  <div>
                    <i class="material-icons d48">add_circle</i>
                  </div>
                  <div class="bmw-lg-video-watchlist-header-button-label" data-toggle="modal" data-target="#addVideos">
                    Add Videos
                  </div>
                  <div class="modal fade" id="addVideos" tabindex="-1" role="dialog" aria-labelledby="addVideosLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content bmw-lg-watchlist-add-videos-modal">
                        <div class="modal-header">
                          <h5 class="modal-title" id="addVideosLabel">Add Video to Watchlist</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          ...
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-primary">Save changes</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-video-watchlist-list">
        <div *ngFor='let video of videoList;let videoIndex=index' class="row bmw-no-gutter bmw-md-video-watchlist-list-video">
          <div class="col-sm-1" style="font-size: 20px; line-height: 2.7">
            {{videoIndex+1}}
          </div>
          <div class="col-sm-2 bmw-no-gutter" style="margin-left: -20px;">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]' [queryParams]='{channel: video.channelNumber,  vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}}/>
              <!-- <div class="bmw-video-home-overlay-text bmw-xs-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-sm-8 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-sm-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemTop(videoIndex, video)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemBottom(videoIndex, video)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemUp(videoIndex, video)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemDown(videoIndex, video)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(video.id)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-video-channel-btn" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432":"#1c69d4"}'
        (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-video-watchlist">
      <div class="bmw-xs watchlist-header">
        <div class="row bmw-no-gutter bmw-lg-video-watchlist-info" style="padding-left: 10px">{{videoList?.length}} videos | 3 hours 38 minutes</div>
        <div class="row bmw-no-gutter" style="color:#1c69d4">
          <a [routerLink]='["/playback"]' [queryParams]='{channel: "", video: "", watchlist: true, playAll: true}'>
            <div style="float:right;margin-left: 5px">
              <i style="font-size: 36px;" class="material-icons">play_circle_filled</i>
            </div>
            <div style="float:right; font-size: 24px;">Play All</div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-video-watchlist-list">
        <div *ngFor='let video of videoList;let videoIndex=index' class="row bmw-no-gutter bmw-md-video-watchlist-list-video">
          <div class="col-xs-6 bmw-no-gutter" style="padding-left: 3px">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]' [queryParams]='{channel: video.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}}/>
              <!-- <div class="bmw-video-home-overlay-text bmw-xs-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-xs-5 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-xs-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemTop(videoIndex, video)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemBottom(videoIndex, video)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === 0}' (click)='moveItemUp(videoIndex, video)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": videoIndex === videoList.length - 1}' (click)='moveItemDown(videoIndex, video)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" (click)='removeFromWatchlist(video.id)'>
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-xs-video-channel-btn bmw-video-channel-btn" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432":"#1c69d4"}'
        (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>